import type { DialogContentNode, TextField } from "@/v2/framework/dialog/types";
import { getSupplementalsByEntity } from "@/services/supplementals";

type CategoryTranslationRow = {
  name?: string | null;
  info?: string | null;
  supplementalNames?: { supplementalNameTypeId: string; name?: string | null }[];
};

/**
 * Translation inputs for the category edit dialog — static keys plus one field per
 * supplemental name type (same discovery pattern as `grid/columns.ts` dynamic slots).
 */
export const buildCategoryTranslationFields = () => {
  const nodes: DialogContentNode[] = [
    {
      type: "text-field",
      name: "name",
      label: "table_columns.name",
      placeholder: "Enter name",
    },
  ];

  const supplementalNameTypes = getSupplementalsByEntity("CATEGORY");
  for (const supplementalNameType of supplementalNameTypes) {
    nodes.push({
      type: "text-field",
      name: `supplementalName_${supplementalNameType.id}`,
      label: `table_columns.${supplementalNameType.name.toLowerCase()}`,
      placeholder: "Enter name",
      valueFormatter: (row: unknown) => {
        const r = row as CategoryTranslationRow;
        return (
          r.supplementalNames?.find(
            (s) => String(s.supplementalNameTypeId) === String(supplementalNameType.id),
          )?.name ?? ""
        );
      },
    });
  }

  return nodes;
};
